import { UpdateContractorVisit } from "@/types/contractorVisit";
import { ContractorVisitsEditorDirectoryFormType } from "./types";
import { UseFormReturn } from "react-hook-form";
import { updateContractorVisit } from "@/schemas/contractorVisit";

export const convertFormToWriteProjectStorePeriodContractorVisit = (
  data: ContractorVisitsEditorDirectoryFormType,
  form: UseFormReturn<ContractorVisitsEditorDirectoryFormType>,
): UpdateContractorVisit[] => {
  const output: UpdateContractorVisit[] = [];
  return Object.entries(data.entries ?? {}).reduce((acc, [id]) => {
    const { isDirty } = form.getFieldState(`entries.${id}`);
    const visit = data.entries[id];

    if (!isDirty || !visit) {
      return acc;
    }

    // Schema handles empty string to null conversion for all fields
    const validatedVisit = updateContractorVisit.parse({
      ...visit,
      id,
    });

    acc.push(validatedVisit);
    return acc;
  }, output);
};
